import { EventEmitter } from "fbemitter";

/**
 * This class exist to minimize the use of RxJS
 * for Emitting Events. RxJS is just purely overkill
 * if we just wanna have a basic event dispatching.
 */
export class EventDispatcher {
  constructor() {
    this.emitter = new EventEmitter();
  }

  dispatch(eventName, event) {
    event.name = eventName;
    this.emitter.emit(eventName, event);
  }
  
  addListener(eventName, callback) {
    return this.emitter.addListener(eventName, callback);
  }
  
  /**
   * Add Listener to list of events calling same callback 
   * function
   * 
   * @param {*} eventNames list of events
   * @param {function} callback function that will be called when one of the events occured
   */
  addListeners(callback, ...eventNames) {
    for (let eventName of eventNames) {
      this.addListener(eventName, callback);
    }
  }
}

export default EventDispatcher;


// WEBPACK FOOTER //
// ./client/app/shared/event/eventdispatcher.service.js